import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { TitleStack, PenceToPounds, DateTime, BlockButton } from "fiver-react-ui-components";
const StyledTable = styled.table`
  width: 100%;
  max-width: 100%;
  border-collapse: separate !important;
  border-spacing: 0;
  border-style: hidden;

  & tr:nth-child(even) td {
    background: #f8f8f9;
  }

  & th {
    padding: 0.75rem 0 1rem;
    text-align: left;
    font-size: 0.75rem;
    font-weight: 600;
    color: ${props => props.theme.colorLabel};
  }

  & td {
    padding: 1rem 0.5rem 1rem 0;
    vertical-align: top;
    font-size: 0.875rem;
    border-bottom: 2px solid ${props => props.theme.colorBorder};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & tr:last-child td {
    border-bottom: none;
  }
`;
const StyledColoredText = styled.span`
  font-weight: 700;
  ${p => p.value === 0 && `color: ${p.theme.colorText}`};
  ${p => p.value > 0 && `color: ${p.theme.colorSuccess}`};
  ${p => p.value < 0 && `color: ${p.theme.colorDanger}`};
`;
const StyledMoreButtonWrapper = styled.div`
  margin-top: 1rem;
`;
const StyledEmptyTransactions = styled.div`
  font-size: 0.875rem;
  color: ${p => p.theme.colorLabel};
`;

const WalletButtonsTable = ({
  onError,
  translations,
  currencySymbol,
  dateLocale,
  transactionsUpdated,
  setTransactionsUpdated
}) => {
  const [isLoading, setLoading] = useState();
  const [transactions, setTransactions] = useState([]);
  const [transactionsTotal, setTransactionsTotal] = useState();
  const [transactionsPage, setTransactionsPage] = useState(1);

  const handleMoreButtonClicked = async e => {
    e.stopPropagation();
    setLoading(true);
    const res = await axios.get(`/wallet/transactions?page=${transactionsPage + 1}&per_page=10`);
    const newTransactions = transactions.concat(res.data.data);
    setTransactions(newTransactions);
    setTransactionsPage(transactionsPage + 1);
    setLoading(false);
  };

  const getTransactions = async () => {
    console.log("refreshing transactions");

    try {
      const transactionsRes = await axios.get(`/wallet/transactions?per_page=10`);
      setTransactions(transactionsRes?.data?.data);
      setTransactionsTotal(transactionsRes?.data?.meta?.total);
    } catch ({
      response
    }) {
      setLoading(false);
      onError(response);
    }
  };

  useEffect(() => {
    getTransactions();
  }, []);
  useEffect(() => {
    if (transactionsUpdated) {
      getTransactions();
      setTransactionsUpdated(false);
    }
  }, [transactionsUpdated]);
  const headers = [{
    text: translations.type,
    width: "40%",
    maxWidth: "160px",
    textAlign: "left"
  }, {
    text: translations.amount,
    width: "30%",
    maxWidth: "70px",
    textAlign: "left"
  }, {
    text: translations.balance,
    width: "30%",
    maxWidth: "70px",
    textAlign: "left"
  }];

  const formatTransactionType = type => {
    let words = type.toLowerCase().replace(/_/g, " ").split(" ");
    let friendlyType = "";
    words.forEach(word => {
      friendlyType += word.substring(0, 1).toUpperCase() + word.substring(1) + " ";
    });

    switch (type) {
      // case "BET":
      //   friendlyType = "Bet";
      //   break;
      // case "WITHDRAWAL_PENDING":
      //   friendlyType = "Withdrawal Pending";
      //   break;
      // case "REFUND":
      //   friendlyType = "Refund";
      //   break;
      case "UBER_VOUCHER_PROGRAM_CODE":
        friendlyType = "Uber Voucher";
        break;
      // case "PRIZE":
      //   friendlyType = "Prize";
      //   break;
      // case "TICKET":
      //   friendlyType = "Ticket";
      //   break;
      // case "DEPOSIT":
      //   friendlyType = "Deposit";
      //   break;
      // case "ADJUSTMENT":
      //   friendlyType = "ADJUSTMENT";
      //   break;

      default:
    }

    return friendlyType;
  };

  return transactions?.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledTable, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, headers.map(h => /*#__PURE__*/React.createElement("th", {
    style: {
      width: h.width,
      textAlign: h.textAlign
    }
  }, h.text)))), /*#__PURE__*/React.createElement("tbody", null, transactions.map((r, i) => /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      width: headers[0].width,
      maxWidth: headers[0].maxWidth,
      textAlign: headers[0].textAlign
    }
  }, /*#__PURE__*/React.createElement(TitleStack, {
    isSmall: true,
    marginBottom: "0",
    title: formatTransactionType(r.type),
    subtitle: /*#__PURE__*/React.createElement(DateTime, {
      format: "DD/MM/YY - h:mm A",
      locale: dateLocale
    }, r.created)
  })), /*#__PURE__*/React.createElement("td", {
    style: {
      width: headers[1].width,
      maxWidth: headers[1].maxWidth,
      textAlign: headers[1].textAlign
    }
  }, r.amount < 0 ? /*#__PURE__*/React.createElement(StyledColoredText, {
    value: r.amount
  }, "-", currencySymbol, (r.amount / 100).toFixed(2).replace("-", "")) : /*#__PURE__*/React.createElement(StyledColoredText, {
    value: r.amount
  }, currencySymbol, /*#__PURE__*/React.createElement(PenceToPounds, null, r.amount))), /*#__PURE__*/React.createElement("td", {
    style: {
      width: headers[2].width,
      maxWidth: headers[2].maxWidth,
      textAlign: headers[2].textAlign,
      paddingRight: "0.5rem"
    }
  }, r.balance < 0 ? /*#__PURE__*/React.createElement(StyledColoredText, {
    value: r.balance
  }, "-", currencySymbol, (r.balance / 100).toFixed(2).replace("-", "")) : /*#__PURE__*/React.createElement(StyledColoredText, {
    value: r.balance
  }, currencySymbol, /*#__PURE__*/React.createElement(PenceToPounds, null, r.balance))))))), transactions.length < transactionsTotal - 10 && /*#__PURE__*/React.createElement(StyledMoreButtonWrapper, null, /*#__PURE__*/React.createElement(BlockButton, {
    size: "sm",
    isLoading: isLoading,
    onClick: handleMoreButtonClicked
  }, "Load more"))) : /*#__PURE__*/React.createElement(StyledEmptyTransactions, null, translations.noTransactionsYet);
};

export default WalletButtonsTable;